<template>
	<div
		class="modal checkout-expired-modal"
		:class="{ 'checkout-expired-modal--dark': darkTheme }"
		@click="close"
	>
		<div class="modal-holder" @click.stop>
			<span class="close-icon" />
			<span class="modal-title">
				Your order has expired. <br />
				Please re-add products and try again.
			</span>
			<div class="modal-buttons">
				<span
					class="button single-button"
					:class="{ disabled: isTicketingRedirectLoading }"
					@click="goToMenu"
				>
					Back
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import eventApi from '@/api/events'

import storage from '@/utils/storage'
import routerMixin from '@/mixins/routerMixin'

export default {
	name: 'ExpiredCheckoutModal',

	mixins: [routerMixin],

	props: {
		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			isTicketingRedirectLoading: false
		}
	},

	computed: {
		...mapState('cart', {
			cartId: 'id',
			eventTicketId: 'eventTicketId'
		}),
		...mapState('venue', ['venueInfo']),
		...mapGetters('cart', ['isTabOpenedByRedemption'])
	},

	methods: {
		...mapActions('cart', ['setReceiptShown']),

		async goToMenu() {
			if (this.isTicketingRedirectLoading) {
				return
			}

			await this.setReceiptShown(this.cartId)
			storage.removeFromStorage('cartId')

			if (this.isTabOpenedByRedemption) {
				await this.redirectToTicketingDestination()

				return
			}

			await this.goToProducts()
			this.close()
		},

		async redirectToTicketingDestination() {
			if (!this.eventTicketId || !this.venueInfo.id) {
				this.goToTicketingEvents()

				return
			}

			try {
				this.isTicketingRedirectLoading = true

				const response = await eventApi.getEventTicket({
					eventTicketId: this.eventTicketId,
					venueId: this.venueInfo.id
				})
				const eventPurchaseOrderId =
					response?.data?.eventPurchaseOrderId ||
					response?.data?.eventPurchaseOrder?.id

				if (eventPurchaseOrderId) {
					this.goToTicketingOrder(eventPurchaseOrderId)

					return
				}

				this.goToTicketingEvents()
			} catch (e) {
				console.error(e)
				this.goToTicketingEvents()
			} finally {
				this.isTicketingRedirectLoading = false
			}
		},

		close() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.checkout-expired-modal {
	.button.disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	.title {
		padding: 20px 0;
		color: #816cc2;
		font-size: 20px;
	}

	&--dark {
		.modal-holder {
			background-color: $dark-blue;

			.modal-title,
			.modal-content {
				color: $white;
			}
		}
	}
}
</style>
